/**
 * @Author: v_jppjpeng
 * @Date: 2023-04-21 09:19:36
 * @Explain: redux 相关配置
 */
// router
import RouterPath from '@/router/routingPath';
// type
import type { BusinessListItemIF } from '@/api/common/data.d';
import { RoleCodeEnum } from '@/api/common/data.d';
import type { LeftMenuIF } from '@/components/leftMenu/data.d';
import { EnvEnum, envType } from '@/config';
// utils
import { isArrayLen } from '@/utils/common/dataJudgment';

interface PermConfigTableIF {
  /** 开放的角色 */
  openRoles: RoleCodeEnum[];
}

const allRoles = [
  RoleCodeEnum.INTERNAL,
  RoleCodeEnum.OWNER,
  RoleCodeEnum.ADMIN,
  RoleCodeEnum.MANAGER,
  RoleCodeEnum.AUTHOR,
  RoleCodeEnum.OPERATOR,
  RoleCodeEnum.VIEWER,
];

// 30045, 30039, 31172, 31135
const commonGameId = [11, 29013, 30061];
// 测试&debug环境额外对30045开通WhatsApp（仅供玉玲使用）
export const shouwWhatsAppGameId = [EnvEnum.DEV, EnvEnum.TEST].includes(
  envType(),
)
  ? [...commonGameId, 30045]
  : commonGameId;

export type MenuListType = {
  icon: string;
  titleKey: string;
  to?: string;
  urlIncludes?: string; // 同级信息中唯一标识
  isShow?: boolean;
  isCollapse?: boolean;
  sticker?: string; // 固定贴纸
  leftMenuList: LeftMenuIF[];
};
// 默认左侧菜单配置生成函数
export const getDefaultLeftMenu = (
  currentBusiness: BusinessListItemIF,
): MenuListType[] => {
  const list = [
    // 首页
    {
      icon: 'menu-header-home',
      titleKey: 'LEFT.MENU.HOME',
      to: RouterPath.HOME,
      urlIncludes: 'home',
      isShow: true,
      // isCollapse: false,
      // children: [],
      leftMenuList: [],
    },
    // 联系人
    {
      icon: 'menu-header-contacts',
      titleKey: 'LEFT.MENU.CONTACTS',
      urlIncludes: 'contacts',
      isShow: true,
      isCollapse: true,
      leftMenuList: [
        // 报表
        {
          icon: 'menu-left-dashboard',
          titleKey: 'LEFT.MENU.DASHBOARD',
          urlIncludes: 'contacts',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 联系人报表
            {
              titleKey: 'LEFT.MENU.OVERVIEW',
              to: RouterPath.CONTACT_REPORT,
              urlIncludes: 'contactReport',
              isShow: true,
              urls: [RouterPath.CONTACT_REPORT],
            },
          ],
        },
        // 联系人信息
        {
          icon: 'menu-left-contacts',
          titleKey: 'LEFT.MENU.USER',
          urlIncludes: 'contacts',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 所有联系人
            {
              titleKey: 'LEFT.MENU.USER1',
              to: RouterPath.CONTACT_MANAGE_LIST,
              urlIncludes: 'contactManage',
              isShow: true,
              urls: [
                // 联系人
                RouterPath.CONTACT_MANAGE_LIST,
                RouterPath.CONTACT_MANAGE_IMPORT_HISTORY,
                RouterPath.CONTACT_MANAGE_DELETE_HISTORY,
                RouterPath.CONTACT_MANAGE_DETAILS,
                RouterPath.CONTACT_MANAGE_ADD_EDIT,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_UPLOAD_FILE,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_WHATSAPP_UPLOAD_FILE,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_MATCH_ATTRIBUTE,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_UPDATE_CONTACTS,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_STATUS,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_PREFERENCE,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_TAG,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_IMPORT_CSV_REVIEW,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_MUMAL,
                RouterPath.CONTACT_MANAGE_ADD_EDIT_NEWSLETTER,
              ],
            },
            // 注册表单管理
            {
              titleKey: 'LEFT.MENU.USER4',
              to: RouterPath.SIGN_UP_FORM_LIST,
              urlIncludes: 'signUpFormManage',
              isShow: true,
              urls: [
                // 表单
                RouterPath.SIGN_UP_FORM_LIST,
                RouterPath.SIGN_UP_FORM_ADD_EDIT,
              ],
            },
          ],
        },
        // Organize
        {
          icon: 'menu-left-management',
          titleKey: 'LEFT.MENU.ORGANIZE',
          urlIncludes: 'contacts',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 标签管理
            {
              titleKey: 'LEFT.MENU.USER2',
              to: RouterPath.LABEL_MANAGE_LIST,
              urlIncludes: 'labelManage',
              isShow: true,
              urls: [
                // 标签
                RouterPath.LABEL_MANAGE_LIST,
                RouterPath.LABEL_MANAGE_LIST_PREDICTIVE_TAGS,
              ],
            },
            // 分层规则
            {
              titleKey: 'LEFT.MENU.USER0',
              to: RouterPath.SEGMENTS_MANAGE_LIST,
              urlIncludes: 'segmentsManage',
              isShow: true,
              urls: [
                // 分层
                RouterPath.SEGMENTS_MANAGE_LIST,
                RouterPath.SEGMENTS_MANAGE_ADD_EDIT,
              ],
            },
            // 字段管理
            {
              titleKey: 'FIELD.SETTINGS.LIST.TITLE',
              to: RouterPath.CONTACT_MANAGE_FIELD_SETTINGS,
              urlIncludes: 'fieldSettings',
              isShow: true,
              urls: [
                // 字段设置
                RouterPath.CONTACT_MANAGE_FIELD_SETTINGS,
                // 字段设置 - 发送详情
                RouterPath.CONTACT_MANAGE_FIELD_SETTINGS_SEND_DETAILS,
              ],
            },
            // 偏好管理
            {
              titleKey: 'LEFT.MENU.USER3',
              to: RouterPath.PREFERENCE_MANAGE_SETTING,
              urlIncludes: 'preferenceManage',
              isShow: true,
              urls: [
                // 偏好
                RouterPath.PREFERENCE_MANAGE_SETTING,
              ],
            },
          ],
        },
        // 资源码
        {
          icon: 'menu-left-economy',
          titleKey: 'LEFT.MENU.ECONOMY',
          urlIncludes: 'content',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 占位符
            {
              titleKey: 'LEFT.MENU.TEMPLATE3',
              to: RouterPath.PLACEHOLDER_MANAGE_LIST,
              urlIncludes: 'placeholderManage',
              isShow: true,
              urls: [
                // 占位符
                RouterPath.PLACEHOLDER_MANAGE_LIST,
                RouterPath.PLACEHOLDER_MANAGE_DETAILS,
              ],
            },
          ],
        },
      ],
    },
    // Email
    {
      icon: 'menu-header-email',
      titleKey: 'LEFT.MENU.EMAIL',
      urlIncludes: 'campaigns',
      isShow: true,
      isCollapse: true,
      leftMenuList: [
        // 活动
        {
          icon: 'menu-left-campaigns',
          titleKey: 'LEFT.MENU.EVENT',
          urlIncludes: 'campaigns',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 常规活动
            {
              titleKey: 'LEFT.MENU.EVENT1',
              to: RouterPath.ACTIVITY_MANAGE_LIST,
              urlIncludes: 'activityManage',
              isShow: true,
              urls: [
                // 常规活动
                RouterPath.ACTIVITY_MANAGE_LIST,
                RouterPath.ACTIVITY_MANAGE_CREATE,
                RouterPath.ACTIVITY_MANAGE_DETAILS,
              ],
            },
            // 周期活动
            {
              titleKey: 'LEFT.MENU.EVENT2',
              to: RouterPath.ACTIVITY_CYCLE_LIST,
              urlIncludes: 'activityCycle',
              isShow: true,
              urls: [
                // 周期活动
                RouterPath.ACTIVITY_CYCLE_LIST,
                RouterPath.ACTIVITY_CYCLE_CRETE,
                RouterPath.ACTIVITY_CYCLE_DETAILS,
              ],
            },
            // A/B 测试
            {
              titleKey: 'LEFT.MENU.EVENT4',
              to: RouterPath.ACTIVITY_AB_TEST_LIST,
              urlIncludes: 'activityAbTest',
              isShow: true,
              urls: [
                // ab活动
                RouterPath.ACTIVITY_AB_TEST_LIST,
                RouterPath.ACTIVITY_AB_TEST_CRETE,
                RouterPath.ACTIVITY_AB_TEST_DETAILS,
                RouterPath.ACTIVITY_AB_TEST_APPROVAL_DETAILS,
              ],
            },
            // 用户旅程
            {
              titleKey: 'LEFT.MENU.EVENT6',
              to: RouterPath.USER_JOURNEY_LIST,
              urlIncludes: 'activityAbTest',
              isShow: true,
              urls: [
                // 用户旅程
                RouterPath.USER_JOURNEY_LIST,
                RouterPath.USER_JOURNEY_CRETE,
                RouterPath.USER_JOURNEY_DETAILS,
              ],
            },
            // 审批活动
            {
              titleKey: 'LEFT.MENU.EVENT3',
              to: RouterPath.ACTIVITY_APPROVAL_LIST,
              urlIncludes: 'activityApproval',
              isShow: true,
              urls: [
                // 活动审批
                RouterPath.ACTIVITY_APPROVAL_LIST,
                RouterPath.ACTIVITY_APPROVAL_DETAILS,
              ],
            },
          ],
        },
        // 模板
        {
          icon: 'menu-left-templates',
          titleKey: 'LEFT.MENU.TEMPLATE',
          urlIncludes: 'mailTemplate',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 营销 邮件模板
            {
              titleKey: 'LEFT.MENU.TEMPLATE.MARKET',
              to: RouterPath.MAIL_TEMPLATE_MARKETING_LIST,
              urlIncludes: 'marketing',
              isShow: true,
              urls: [
                // 模板
                RouterPath.MAIL_TEMPLATE_MARKETING_LIST,
                RouterPath.MAIL_TEMPLATE_MARKETING_CREATE,
                RouterPath.MAIL_TEMPLATE_MARKETING_ADD_EDIT,
              ],
            },
            // 事务 邮件模板
            {
              titleKey: 'LEFT.MENU.TEMPLATE.TRANSACTION',
              to: RouterPath.MAIL_TEMPLATE_TRANSACTIONAL_LIST,
              urlIncludes: 'transactional',
              isShow: true,
              urls: [
                // 模板
                RouterPath.MAIL_TEMPLATE_TRANSACTIONAL_LIST,
                RouterPath.MAIL_TEMPLATE_TRANSACTIONAL_CREATE,
                RouterPath.MAIL_TEMPLATE_TRANSACTIONAL_ADD_EDIT,
              ],
            },
          ],
        },
        // 分析
        {
          icon: 'menu-left-analytics',
          titleKey: 'LEFT.MENU.ANALYTICS',
          urlIncludes: 'report',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 活动报表
            {
              titleKey: 'LEFT.MENU.ACTIVITY.REPORT',
              to: RouterPath.ACTIVITY_REPORT_LIST,
              urlIncludes: 'activityReport',
              isShow: true,
              urls: [
                // 报表
                RouterPath.ACTIVITY_REPORT_LIST,
                RouterPath.ACTIVITY_REPORT,
                RouterPath.ACTIVITY_GROUP_REPORT,
                RouterPath.ACTIVITY_REPORT_LINKS_CLICKED,
              ],
            },
          ],
        },
      ],
    },
    // WhatsApp
    {
      icon: 'menu-header-whatsApp',
      titleKey: 'LEFT.MENU.WHATSAPP',
      urlIncludes: 'activityWhatsApp',
      isShow: true,
      isCollapse: true,
      leftMenuList: [
        // 活动
        {
          icon: 'menu-left-campaigns',
          titleKey: 'LEFT.MENU.EVENT.WHATSAPP',
          urlIncludes: 'campaigns',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // WhatsApp
            {
              titleKey: 'LEFT.MENU.EVENT1',
              to: RouterPath.ACTIVITY_WHATSAPP_LIST,
              urlIncludes: 'activityWhatsApp',
              isShow: true,
              // isShow: shouwWhatsAppGameId.includes(currentBusiness.gameId),
              urls: [
                // WhatsApp活动
                RouterPath.ACTIVITY_WHATSAPP_LIST,
                RouterPath.ACTIVITY_WHATSAPP_CRETE,
                RouterPath.ACTIVITY_WHATSAPP_DETAILS,
              ],
            },
          ],
        },
        // 模板
        {
          icon: 'menu-left-watemplates',
          titleKey: 'LEFT.MENU.WHATSAPP.TEMPLATE',
          urlIncludes: 'content',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // WhatsApp 模板
            {
              titleKey: 'LEFT.MENU.TEMPLATE.MARKET',
              to: RouterPath.WHATSAPP_TEMPLATE_LIST,
              urlIncludes: 'whatsAppTemplate',
              isShow: true,
              // isShow: shouwWhatsAppGameId.includes(currentBusiness.gameId),
              urls: [
                // WhatsApp模板
                RouterPath.WHATSAPP_TEMPLATE_LIST,
                RouterPath.WHATSAPP_TEMPLATE_ADD_OR_EDIT,
              ],
            },
          ],
        },
      ],
    },
    // Playtest hub
    {
      icon: 'menu-header-playtestHub',
      titleKey: 'LEFT.MENU.PLAYTEST.HUB',
      urlIncludes: 'testerManage',
      isShow: true,
      isCollapse: true,
      sticker: require('@/assets/images/testerManage/beta.png'),
      leftMenuList: [
        // Playtest hub
        {
          icon: 'menu-test-player',
          titleKey: 'LEFT.MENU.TEST.MANAGEMENT',
          urlIncludes: 'testerManage',
          isShow: true,
          isCollapse: true,
          urls: [],
          children: [
            // 测试玩家管理模块
            {
              titleKey: 'LEFT.MENU.TESTER.LIST',
              to: RouterPath.TESTER_MANAGE_LIST,
              urlIncludes: 'whatsAppTemplate',
              isShow: true,
              urls: [
                // 测试玩家管理模块
                RouterPath.TESTER_MANAGE_LIST,
                RouterPath.TESTER_MANAGE_ADD_OR_EDIT,
                RouterPath.TESTER_MANAGE_TEST_MANAGE_LIST,
              ],
            },
          ],
        },
      ],
    },
    // userCenter
    {
      icon: 'menu-header-whatsApp',
      titleKey: '',
      urlIncludes: 'userCenter',
      isShow: false,
      leftMenuList: [
        // 我的项目
        {
          titleKey: 'LEFT.MENU.DASHBOARD',
          to: RouterPath.SETTING_MANAGE,
          urlIncludes: 'userCenter',
          isShow: true,
          children: [],
          urls: [
            // 我的项目
            RouterPath.BUSINESS_MANAGE_CREATE,
            RouterPath.BUSINESS_MANAGE_JOIN,
            RouterPath.BUSINESS_MANAGE_MY_PROJECT_LIST,
          ],
        },
        // 项目设置
        {
          titleKey: 'LEFT.MENU.DASHBOARD',
          to: RouterPath.SETTING_MANAGE,
          urlIncludes: 'userCenter',
          isShow: true,
          children: [],
          urls: [
            // 设置管理
            RouterPath.SETTING_MANAGE,
            RouterPath.SETTING_MANAGE_DOMAIN_AUTH_LIST,
            RouterPath.SETTING_MANAGE_DOMAIN_AUTH_ADD_EDIT,
            RouterPath.SETTING_MANAGE_DOMAIN_AUTH_DETAILS,
            RouterPath.SETTING_MANAGE_SENDER_ADDRESS_LIST,
            RouterPath.SETTING_MANAGE_SENDER_NAME_LIST,
            RouterPath.SETTING_MANAGE_REJECT_LIST,
            RouterPath.SETTING_MANAGE_SENDING_FREQUENCY_CONTROL,
            RouterPath.SETTING_MANAGE_API_KEY_LIST,
            RouterPath.SETTING_MANAGE_API_KEY_DETAILS,
            RouterPath.SETTING_MANAGE_API_KEY_SETTING,
            RouterPath.SETTING_MANAGE_WEB_HOOKS_LIST,
            RouterPath.SETTING_MANAGE_TEST_MAIL_LIST,
            RouterPath.SETTING_MANAGE_AREA_LIST,
            RouterPath.SETTING_MANAGE_DOUBLE_OPT_IN_CONFIG,
          ],
        },
        // 用户管理
        {
          titleKey: 'LEFT.MENU.DASHBOARD',
          to: RouterPath.USER_MANAGE_LIST,
          urlIncludes: 'userCenter',
          isShow: true,
          children: [],
          urls: [
            // 用户管理
            RouterPath.USER_MANAGE_LIST,
            RouterPath.USER_MANAGE_ADD_OR_EDIT,
            RouterPath.USER_MANAGE_MY_PROFILES,
          ],
        },
        // 账号中心
        {
          titleKey: 'LEFT.MENU.DASHBOARD',
          to: RouterPath.USER_MANAGE_MY_PROFILES,
          urlIncludes: 'userCenter',
          isShow: true,
          children: [],
          urls: [
            // 账号中心
            RouterPath.USER_MANAGE_MY_PROFILES,
          ],
        },
        // 版本
        {
          titleKey: 'LEFT.MENU.DASHBOARD',
          to: RouterPath.VERSIONS,
          urlIncludes: 'userCenter',
          isShow: true,
          children: [],
          urls: [
            // 版本
            RouterPath.VERSIONS,
          ],
        },
        // 导出中心
        {
          titleKey: 'LEFT.MENU.EXPORT.CENTER',
          to: RouterPath.EXPORT_CENTER_LIST,
          urlIncludes: 'userCenter',
          isShow: true,
          children: [],
          urls: [
            // 设置管理
            RouterPath.EXPORT_CENTER_LIST,
          ],
        },
      ],
    },
    // other
    // {
    //   icon: 'menu-header-home',
    //   titleKey: '',
    //   urlIncludes: 'other',
    //   isShow: false,
    //   urls: [
    //     RouterPath.NO_PERMISSION,
    //     RouterPath.TRANSFER,
    //     RouterPath.LOGIN,
    //     RouterPath.REGISTER,
    //     RouterPath.FORGOT_PASSWORD,
    //     RouterPath.WELCOME_PAGE,
    //     RouterPath.VIEW_TEMPLATE,
    //     RouterPath.NO_AUTH_PAGE,
    //   ],
    // },
  ];

  let result = [];
  for (let i = 0; i < list.length; i++) {
    const item: MenuListType = list[i];
    item.leftMenuList = item.leftMenuList?.filter((v: LeftMenuIF) => {
      v.children = v.children.filter((child) => child.isShow) || [];
      return isArrayLen(v.children) || v?.to;
    });
    result.push(item);
  }

  result = result.filter((item) => item?.to || isArrayLen(item.leftMenuList));
  return result;
};

// 权限配置表
export const permConfigTable: Record<any, PermConfigTableIF> = {
  // 审批活动
  [RouterPath.ACTIVITY_APPROVAL_LIST]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 联系人 - 列表
  [RouterPath.CONTACT_MANAGE_LIST]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 联系人 - 详情
  [RouterPath.CONTACT_MANAGE_DETAILS]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 联系人 - 新增、编辑
  [RouterPath.CONTACT_MANAGE_ADD_EDIT]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 导出中心 - 导出历史
  [RouterPath.EXPORT_CENTER_LIST]: {
    openRoles: [RoleCodeEnum.INTERNAL, RoleCodeEnum.OWNER],
  },
  // 域名 - 新增、编辑
  [RouterPath.SETTING_MANAGE_DOMAIN_AUTH_ADD_EDIT]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 测试玩家管理模块 - 测试人列表
  [RouterPath.TESTER_MANAGE_LIST]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 测试玩家管理模块 - 测试配置
  [RouterPath.TESTER_MANAGE_ADD_OR_EDIT]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 测试玩家管理模块 - 测试管理列表
  [RouterPath.TESTER_MANAGE_TEST_MANAGE_LIST]: {
    openRoles: [
      RoleCodeEnum.INTERNAL,
      RoleCodeEnum.OWNER,
      RoleCodeEnum.ADMIN,
      RoleCodeEnum.MANAGER,
    ],
  },
  // 报表 - 导出链接导出页面
  [RouterPath.ACTIVITY_REPORT_LINKS_CLICKED]: {
    openRoles: [RoleCodeEnum.INTERNAL, RoleCodeEnum.OWNER],
  },
  other: {
    openRoles: allRoles,
  },
};
